export enum ContactType {
    HeadOfDesk = 'HeadOfDesk',
    DistributionList = 'DistributionList',
}
